<!-- Console delegation V1.0; 2026-10-07 09:05:47 CST; parent dcebd36069b2ddb3e45e586f2c90a0214b9a2a4f. -->
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { httpClient } from '../api/client';
import { saveDelegation, endDelegation, type DelegationSession } from '../auth/delegationSession';
const message = ref('正在安全进入客户控制台…');
const failed = ref(false);
onMounted(async () => {
  const ticket = new URLSearchParams(window.location.hash.slice(1)).get('ticket');
  window.history.replaceState(null, '', window.location.pathname);
  if (window.location.pathname === '/delegation-ended') {
    message.value = '客户代理会话已结束。请返回运营后台，重新选择客户进入。';
    failed.value = true; return;
  }
  endDelegation();
  try {
    if (!ticket || !/^[A-Za-z0-9_-]{43}$/.test(ticket)) throw new Error('进入链接无效，请从运营后台重新进入。');
    const session = await httpClient.post<Omit<DelegationSession, 'expiresAt'> & { expiresIn: number }>(
      '/api/v1/auth/delegation/exchange', { ticket });
    saveDelegation(session);
    window.location.replace('/domains');
  } catch (error) {
    message.value = error instanceof Error ? error.message : '进入失败，请从运营后台重新进入。';
    failed.value = true;
  }
});
</script>
<template>
  <main class="delegation-entry" aria-live="polite">
    <h1>{{ failed ? '客户代理会话' : '进入客户控制台' }}</h1>
    <p>{{ message }}</p>
    <a v-if="failed" href="https://admin.hotxcdn.net/customers" target="_blank" rel="noopener noreferrer">返回客户管理</a>
  </main>
</template>
<style scoped>
.delegation-entry { max-width: 520px; margin: 15vh auto; padding: 28px; border: 1px solid #d4e2dc; border-radius: 12px; background: white; color: #17362b; }
.delegation-entry h1 { font-size: 22px; }
.delegation-entry p { line-height: 1.7; }
</style>
